import {useState} from "react";
import Box from "@mui/material/Box";

/*
import {Editor, EditorState} from 'draft-js';
import 'draft-js/dist/Draft.css';
*/

export default function TestPage() {

    const [editorState, setEditorState] = useState(
//        () => EditorState.createEmpty(),
    );

    return (
        <Box
            component="span"
            sx={{display: 'inline-block', mx: '2px', transform: 'scale(0.8)'}}
        >
{/*
            <Editor editorState={editorState} onChange={setEditorState}/>
*/}
        </Box>
    )
}
